import ModalHeader from '@molecules/ModalHeader';
import ModalWindow from '@organisms/modals/ModalWindow';
import {FC, useEffect, useState} from 'react';
import {ButtonsWrapper, ModalContent, ModalWrapper} from './AddSystemModal.styles';
import Button from '@atoms/Button';
import Input from '@atoms/Input';
import {useDispatch} from 'react-redux';
import {addTest, editTest} from '@store/slices/tests';
import {AppDispatch} from '@store';
import {ITest} from '@types';

interface Props {
  isOpened: boolean;
  onCloseRequest: () => void;
  test?: ITest;
}

const AddTestModal: FC<Props> = ({isOpened, onCloseRequest, test}) => {
  const [testName, setTestName] = useState<string>('');
  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (test?.name) {
      setTestName(test.name);
    } else {
      setTestName('');
    }
  }, [test]);

  const AddTest = () => {
    if (test?.id) {
      dispatch(editTest({name: testName, id: test.id}));
    } else {
      dispatch(
        addTest({
          name: testName,
        }),
      );
    }
    setTestName('');
    onCloseRequest();
  };

  return (
    <ModalWindow isOpen={isOpened} overflowIsVisible>
      <ModalWrapper>
        <ModalHeader
          title={test?.id ? 'Редактировать тест' : 'Добавить тест'}
          onClose={onCloseRequest}
        />
        <ModalContent>
          <Input
            id="test-name"
            label="Название теста"
            value={testName}
            onChange={e => {
              setTestName(e.currentTarget.value);
            }}
            withoutErrorText
            hint="Максимум 50 символов"
            maxLength={50}
          />
        </ModalContent>
        <ButtonsWrapper>
          <Button
            fullWidth
            title={test?.id ? 'Сохранить' : 'Добавить'}
            variant="filled"
            disabled={!testName}
            onClick={AddTest}
          />
          <Button
            fullWidth
            title="Закрыть"
            onClick={() => {
              onCloseRequest();
              setTestName('');
            }}
          />
        </ButtonsWrapper>
      </ModalWrapper>
    </ModalWindow>
  );
};

export default AddTestModal;
